// import { Link } from 'found'
import React, { Component } from 'react'
import { createFragmentContainer } from 'react-relay'
import graphql from 'babel-plugin-relay/macro' 

import LinkResolver from '../../link-resolver'

class MenuItem extends Component {

    constructor(props) {
        super(props)
        this.state = {
            hover: false,
        }
    }

    render() {
        const { i, item } = this.props

        return (
            <div key={i} className="column-36 w-col w-col-4 w-col-medium-4">
                <div
                    style={{ background: item.color, opacity: this.state.hover ? 0.75 : 1 }}
                    className="stores_hover"
                    onMouseEnter={() => this.setState({ hover: true })}
                    onMouseLeave={() => this.setState({ hover: false })}
                >
                    <a
                        target={item.link.target || ''}
                        href={item.link.url || LinkResolver(item.link)}
                        className="link-block-6 w-inline-block"
                    >
                        <div style={{ textTransform: 'uppercase' }} className="text-block-21">
                            {item.title}
                        </div>
                        <div style={{ textTransform: 'uppercase' }} className="text-block-22">
                            {item.subtitle}
                        </div>
                    </a>
                    <div
                        style={{ textTransform: 'uppercase', opacity: this.state.hover ? 1 : 0 }}
                        className="text-block-26"
                    >
                        {item.hoverCaption}
                    </div>
                </div>
                <div className="image-store">
                    <img alt="" src={item.picture} className="image-31" />
                </div>
            </div>
        )
    }
}

function MenuSection({ menu }) {

    return (
        <div className="section-5">
            <div className="row-17 w-row">
                {menu.slice(0, 3).map((item, i) => <MenuItem key={i} i={i} item={item} />)}
            </div>
            <div className="row-17 w-row">
                {menu.slice(3, 6).map((item, i) => <MenuItem key={i} i={i} item={item} />)}
            </div>
        </div>
    )
}

const connectRelay = MenuSection => class extends Component {

    render() {
        // const { routeResolver } = this.props.context
        return <MenuSection menu={this.props.home.menu} />
    }
}

export default createFragmentContainer(
    connectRelay(MenuSection),
    graphql`
        fragment menuSection_home on Home {
            menu {
                title
                subtitle
                hoverCaption
                link {
                    id
                    uid
                    type
                    slug
                    link_type
                    url
                    target
                }
                color
                picture
            }
        }
    `
)
